import { render, staticRenderFns } from "./templatesDataExportWidget.vue?vue&type=template&id=3641221e&scoped=true"
import script from "./templatesDataExportWidget.vue?vue&type=script&lang=js"
export * from "./templatesDataExportWidget.vue?vue&type=script&lang=js"
import style0 from "./templatesDataExportWidget.vue?vue&type=style&index=0&id=3641221e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3641221e",
  null
  
)

export default component.exports